import { render } from "./ContatoView.vue?vue&type=template&id=4ac16ffc"
import script from "./ContatoView.vue?vue&type=script&lang=js"
export * from "./ContatoView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__